import React from 'react';
import { useTranslation } from 'react-i18next';
import { Client } from '@/types/client';
import Grid, { itemList, itemText } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';

const View: React.FC<{ client: Client }> = ({ client }) => {
  const { t } = useTranslation();

  const items = [
    itemText(t('client.status_permisions.active_since'), client.accountCreatedAt),
    itemText(
      t('client.status_permisions.client_info_status'),
      client.clientInfoStatus,
      undefined,
      client.customerStatusColor,
    ),
    itemText(t('client.status_permisions.client_info_description'), client.clientInfoDescription),
    itemList(t('client.status_permisions.flags_permisions'), client.flags),
    itemText(
      t('client.status_permisions.transfer_authorized'),
      client.isTransferAuthorized ? `✅ ${t('common.authorized')}` : `❌ ${t('common.inactive')}`,
    ),
  ];

  return (
    <Container
      title={t('client.status_permisions.title')}
      actions={[]}
      testId="status_permisions"
    >
      <Grid
        column={5}
        items={items}
      />
    </Container>
  );
};

export default View;
